<template>
  <div class="">
    <div class="disabled" :class="[value]" v-if="disabled">
      <p class="title el-input el-input--mini" v-text="value"></p>
    </div>
    <ts-select
      v-else
      :placeholder="placeholder"
      :size="size"
      :value="value"
      :style="{ width: width ? `${width}px` : undefined }"
      class="select"
      :class="[value]"
      @change="handleValueChange"
    >
      <el-option v-for="item in items" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </ts-select>
  </div>
</template>

<style lang="scss" scoped>
.disabled {
  box-shadow: inset -5px -5px 10px 0 #fafbff, inset 5px 5px 10px 0 #a6abbd;
  border-radius: 47px;
  display: inline-block;
  .title {
    user-select: none;
    text-align: center;
    border-radius: 16px;
    line-height: 18px;
    padding: 4px 16px;
    font-size: 12px;
    // box-shadow: 5px 5px 10px 0 rgb(166 171 189 / 48%), -5px -5px 10px 0 rgb(250 251 255 / 80%);
    border: solid 2px rgba(255, 255, 255, 0.16);
    background-blend-mode: soft-light, normal;
    background-clip: padding-box;
    background: #ebecf0;
    background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  }
}
.select::v-deep,
.disabled {
  width: 120px;

  .el-input .el-select__caret {
    color: black;
  }
}
</style>

<script>
export default {
  name: 'custom-select',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'mini'
    },
    width: {
      type: Number,
      default: 0
    }
  },
  computed: {
    selectedItems() {
      return this.items.filter(status => status.selectable);
    }
  },
  methods: {
    handleValueChange(value) {
      this.$emit('input', value);
    }
  }
};
</script>
